import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import * as healthDataReducers from '../reducer';
import * as actionMgr from '../action-mgr';
import * as constants from '../constants';
import * as strings from '../../helpers/strings';
import * as userStationsReducers from '../../system/reducer/UserStationsReducers';

var fetchHealthDataInterval;

const styles = {
  countContainer: {
    height: 124,
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: 'pointer'
  },
  
  count: {
    fontSize: "2rem",
    margin: 0,
    fontWeight: 500,
  },
  countLabel: {
    // color: "rgba(0,0,0,1)",
    fontSize: "1rem",
    fontWeight: 400,
    textAlign: "center"
  },
  countTotal: {
    color: "#343A40",
    // color: "#448aff",
  },
  countContainerTotal: {
    background: 'linear-gradient(0deg, #343A40, 3%, #F8F8F8 1%)',
    
    transition: "all .2s ease-in-out",
    '&:hover': {
      background: 'linear-gradient(0deg, #2B2B2B, 5%, #F8F8F8)',
      // background: 'linear-gradient(0deg, #448aff, 3%, #ECF2FF 1%)',
      transform: 'scale(1.05)',
      transformOrigin: 'center'
    }
  },
  countNotConnected: {
    // color: "#343A40",
    color: "#B71C1C"
  },
  countContainerNotConnected: {
    background: 'linear-gradient(0deg, #343A40, 3%, #F8F8F8 1%)',
    // background: 'linear-gradient(0deg, #B71C1C, 5%, #F8C4B4)',
    transition: "all .2s ease-in-out",
    '&:hover': {
      background: 'linear-gradient(0deg, #B04759, 5%, #F8F8F8)',
      // background: 'linear-gradient(0deg, #B71C1C, 3%, #ECF2FF 1%)',
      transform: 'scale(1.05)',
      transformOrigin: 'center'
    }
  },
  countNoError: {
    // color: "#343A40",
    color: "#00C853"
  },
  countContainerNoError: {
    background: 'linear-gradient(0deg, #343A40, 3%, #F8F8F8 1%)',
    // background: 'linear-gradient(0deg, #00C853, 5%, #B5F1CC)',
    transition: "all .2s ease-in-out",
    '&:hover': {
      background: 'linear-gradient(0deg, #00C853, 5%, #F8F8F8)',
      // background: 'linear-gradient(0deg, #00C853, 3%, #ECF2FF 1%)',
      transform: 'scale(1.05)',
      transformOrigin: 'center'
    }
  },
  countError: {
    // color: "#343A40",
    color: "#FB8C00"
  },
  countContainerError: {
    background: 'linear-gradient(0deg, #343A40, 3%, #F8F8F8 1%)',
    // background: 'linear-gradient(0deg, #FB8C00, 5%, #F7EDDB)',
    transition: "all .1s ease-in-out",
    '&:hover': {
      background: 'linear-gradient(0deg, #FB8C00, 5%, #F8F8F8)',
      // background: 'linear-gradient(0deg, #FB8C00, 3%, #ECF2FF 1%)',
      transform: 'scale(1.05)',
      transformOrigin: 'center'
    }
  }
}

class StationsSummary extends Component {
  constructor() {
    super();

    this.detectOffline = this.detectOffline.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { fetchLatestHealthData, stations } = this.props;
    var intervalId = setInterval(this.detectOffline, 1000);
    this.props.setOfflineIntervalId(intervalId);

    clearInterval(fetchHealthDataInterval)
 
    fetchHealthDataInterval = setInterval(() => {
      fetchLatestHealthData(stations);
    }, 10000)
  }

  componentWillUnmount() {
    const { offlineIntervalId, clearOfflineIntervalId } = this.props;
    clearInterval(offlineIntervalId);
    clearInterval(fetchHealthDataInterval);
    clearOfflineIntervalId();
  }

  handleClick = data => e => {
    const { history } = this.props;
    history.push(`/stations-health?status=${data}`);
  }

  detectOffline = () => {
    const { healthDataList, setErrorType } = this.props;
    // const currentTimestamp = new Date().getTime();
    const currentTimestamp = Date.parse(new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" })) // Convert any system time to SGT
    for (var i = 0; i < healthDataList.length; i++) {
      if (healthDataList[i].errorType !== constants.ERROR_TYPE_NOT_CONNECTED) {
        var diffTimestamp = currentTimestamp - healthDataList[i].timestamp;
        if (diffTimestamp > 300000) {// more than two min
          setErrorType(healthDataList[i].stationId, constants.ERROR_TYPE_NOT_CONNECTED);

          var healthPointer = document.getElementById(`point_${healthDataList[i].stationId}`);
          if (healthPointer)
            healthPointer.style.backgroundColor = "#B71C1C";
        }
      }
    }
  }

  render() {
    const { healthSummary, classes } = this.props;
    return (
      
      <Grid container spacing={8} >
        <Grid item md={3} sm={6} xs={6} onClick={this.handleClick("0")}>
          <Paper className={`${classes.countContainer} ${classes.countContainerTotal}`}>
            <h1 className={classes.count + " " + classes.countTotal}>{healthSummary.notConnected + healthSummary.noError + healthSummary.error}</h1>
            <span className={classes.countLabel}>{strings.lblTotalRemoteStation}</span>
          </Paper>
        </Grid>
        <Grid item md={3} sm={6} xs={6} onClick={this.handleClick("1")}>
          <Paper className={`${classes.countContainer} ${classes.countContainerNoError}`}>
            <h1 className={classes.count + " " + classes.countNoError}>{healthSummary.noError}</h1>
            <span className={classes.countLabel}>{strings.lblHealthy}</span>
          </Paper>
        </Grid>
        <Grid item md={3} sm={6} xs={6} onClick={this.handleClick("200")}>
          <Paper className={`${classes.countContainer} ${classes.countContainerError}`}>
            <h1 className={classes.count + " " + classes.countError}>{healthSummary.error}</h1>
            <span className={classes.countLabel}>{strings.lblWarning}</span>
          </Paper>
        </Grid>
        <Grid item md={3} sm={6} xs={6} onClick={this.handleClick("-1")}>
          <Paper className={`${classes.countContainer} ${classes.countContainerNotConnected}`}>
            <h1 className={classes.count + " " + classes.countNotConnected}>{healthSummary.notConnected}</h1>
            <span className={classes.countLabel}>{strings.lblNotConnected}</span>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  healthDataList: healthDataReducers.getLiveHealthDataList(state),
  healthSummary: healthDataReducers.getHealthSummary(state),
  offlineIntervalId: healthDataReducers.getOfflineIntervalId(state),

  stations: userStationsReducers.getStations(state),
});

export default connect(mapStateToProps, actionMgr)(
  withRouter(
    withStyles(styles)(StationsSummary)
  )
);